// extracted by mini-css-extract-plugin
export default {"root":"IconCoachValidated_root__F9aKH"};